import * as React from 'react';
import { IOrderListItem } from '../../Entities';
import { capitalize } from '../../../../../shared/StringExtensions';
import OrderList from './OrderList';

type OrderListSectionProps = {
    title: string;
    orders: IOrderListItem[];
    user: any;
    navigateTo: (route: string) => void;
    newOrderId: number | null;
};

function OrderListSection({ title, orders, user, navigateTo, newOrderId }: OrderListSectionProps) {
    return (
        <div>
            <h2>{capitalize(title)}</h2>
            <OrderList
                orders={orders}
                user={user}
                navigateTo={navigateTo}
                newOrderId={newOrderId}
            />
        </div>
    );
}

export default OrderListSection;
